import React, { useEffect } from 'react';
import { useMessages } from '../contexts/MessageContext';
import { List, ListItem, ListItemText, ListItemAvatar, Avatar, Typography, Badge, CircularProgress } from '@material-ui/core';
import { formatDistanceToNow } from 'date-fns';
import { Sms as SmsIcon, SmsFailed as UnreadIcon } from '@material-ui/icons';
import styled from 'styled-components';

const StyledListItem = styled(ListItem)`
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
`;

const MessageList = () => {
    const { messages, messageThreads, loading, error, unreadCount, selectedMessage, setSelectedMessage, markAsRead } = useMessages();

    useEffect(() => {
        if (selectedMessage) {

            if (selectedMessage.status === 'unread') {
                markAsRead(selectedMessage.id);
            }
        }
    }, [selectedMessage, markAsRead]);

    if (loading) return <CircularProgress />;
    if (error) return <Typography color="error">{error}</Typography>;

    return (
        <List style={{ maxHeight: '90vh', overflowY: 'auto' }}>
            {messageThreads.map((message) => (
                <StyledListItem
                    key={message.id}
                    selected={selectedMessage?.id === message.id}
                    onClick={() => setSelectedMessage(message)}
                >
                    <ListItemAvatar>
                        <Badge
                            badgeContent={message.status === 'unread' ? ' ' : 0}
                            color="error"
                            variant="dot"
                            overlap="circular"
                        >
                            <Avatar>
                                {message.status === 'unread' ? <UnreadIcon /> : <SmsIcon />}
                            </Avatar>
                        </Badge>
                    </ListItemAvatar>
                    <ListItemText
                        primary={
                            <Typography variant="subtitle1" noWrap>
                                {message.from_number}
                            </Typography>
                        }
                        secondary={
                            <>
                                <Typography variant="body2" noWrap>
                                    {message.body}
                                </Typography>
                                <Typography variant="caption">
                                    {formatDistanceToNow(new Date(message.created_at), { addSuffix: true })}
                                </Typography>
                            </>
                        }
                    />
                </StyledListItem>
            ))}
        </List>
    );
};

export default MessageList;